export default {"src":"/_next/static/media/payment-logos.af65867a.svg","height":22,"width":157,"blurWidth":0,"blurHeight":0};